import React from 'react';

import EntityPickerModalLoadMoreButton from './EntityPickerModalLoadMoreButton';
import EntityPickerModalLoadMoreError from './EntityPickerModalLoadMoreError';
import EntityPickerModalLoadMoreLoader from './EntityPickerModalLoadMoreLoader';
import { CommonReferencePickerPlugin } from '../types/ReferencePickerPlugin';
import {
  EntityWithId,
  PluginQueryFilters,
  SetSelectionHandler,
} from '../types/types';

interface EntityPickerModalListContentProps<T = EntityWithId> {
  loading?: boolean;
  error?: boolean | object;
  onTryAgain: () => void;
  onLoadMore: (() => Promise<void>) | null;
  selectedIds: string[];
  disabledIds?: string[];
  multiple?: boolean;
  entities: T[];
  onChange: (params: { entity: T; checked: boolean }) => void;
  setSelection: SetSelectionHandler<T>;
  disabled?: boolean;
  filters: PluginQueryFilters;
  plugin: CommonReferencePickerPlugin;
  isPluginDisabledInEntitlements?: boolean;
}

const EntityPickerModalListContent = <T extends EntityWithId>({
  onLoadMore,
  selectedIds,
  disabledIds,
  multiple,
  entities,
  loading,
  error,
  onTryAgain,
  onChange,
  setSelection,
  disabled,
  filters,
  plugin,
  isPluginDisabledInEntitlements: _isPluginDisabledInEntitlements,
}: EntityPickerModalListContentProps<T>) => {
  const showLoader = plugin && loading;
  const showError = plugin && error && !showLoader;
  const LoadMoreButton =
    plugin.CustomPickerLoadMoreButton || EntityPickerModalLoadMoreButton;
  const LoadMoreLoader =
    plugin.CustomPickerLoadMoreLoader || EntityPickerModalLoadMoreLoader;
  const LoadMoreError =
    plugin.CustomPickerLoadMoreError || EntityPickerModalLoadMoreError;

  return (
    <div>
      <div>
        {entities.map((entity) => {
          const { EntityPickerItem } = plugin;
          return (
            EntityPickerItem && (
              <EntityPickerItem
                key={entity.id}
                entity={entity}
                multiple={!!multiple}
                onChange={
                  multiple
                    ? (checked: boolean) => onChange({ entity, checked })
                    : () => setSelection([entity])
                }
                disabled={disabled || !!disabledIds?.includes(entity.id)}
                selected={selectedIds?.includes(entity.id)}
                filters={filters}
              />
            )
          );
        })}
      </div>
      {onLoadMore && !showLoader && !showError && (
        <LoadMoreButton onLoadMore={onLoadMore} />
      )}
      {showLoader && <LoadMoreLoader />}
      {showError && <LoadMoreError onTryAgain={onTryAgain} />}
    </div>
  );
};

export default EntityPickerModalListContent;
